module.exports = __webpack_public_path__ + "static/media/Sec-2_2677_AboutUs_EN.4f079aa7.webp";